import { useMarketplacePreviewItems } from '@/apis/marketplace-preview/hooks/useMarketplacePreviewItems'
import { useMarketplacePreviewStores } from '@/apis/marketplace-preview/hooks/useMarketplacePreviewStores'
import { useApplicantProgramYears } from '@/app/SchoolYearProvider'
import { usePagination } from '@/common/hooks/usePagination.tsx'
import { useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'

export function useMarketplacePreviewData() {
  // Local state
  const [itemSearch, setItemSearch] = useState('')
  const [storeSearch, setStoreSearch] = useState('')
  const [selectedFilter, setSelectedFilter] = useState<string>('')
  const [isStoresView, setIsStoresView] = useState(true)
  const debouncedStoreSearch = useDebounce(storeSearch, 500)

  // Derived state
  const debouncedItemSearch = useDebounce(itemSearch, 500)
  const { selectedProgramId } = useApplicantProgramYears()
  const { currentPage, perPage, setCurrentPage, setPerPage } = usePagination()

  // Data fetching
  const storesQuery = useMarketplacePreviewStores({
    perPage,
    page: 1,
    search: debouncedStoreSearch,
    business_type: selectedFilter,
  })
  const itemsQuery = useMarketplacePreviewItems({
    perPage,
    page: currentPage,
    search: debouncedItemSearch,
  })

  const handleFilterOnChange = (item: { id: number; name: string }) => {
    setSelectedFilter(
      item.id == 0 ? '' : item.id == 1 ? '1,2' : item.id.toString()
    )
  }

  const handleToggleView = (viewType: 'items' | 'stores') => {
    setIsStoresView(viewType === 'stores')
    setItemSearch('')
    setStoreSearch('')
    setSelectedFilter('')
  }

  return {
    // queries
    storesQuery,
    itemsQuery,

    storeSearch,
    setStoreSearch,

    // State
    itemSearch,
    selectedFilter,
    isStoresView,
    selectedProgramId,

    // Pagination
    currentPage,
    perPage,
    setCurrentPage,
    setPerPage,

    // Handlers
    handleFilterOnChange,
    handleToggleView,
    setItemSearch,
  }
}
